import * as actionTypes from '../actions/actionTypes';

const initialState = {
    events: null,
    selectedEventID: null,
    loading: false,
    noMoreEvents: false,
    first: 0
};

const reducer = (state = initialState, action) => {
    switch(action.type) {
        case actionTypes.GET_EVENTS:
            return {
                ...state,
                noMoreEvents: false,
                loading: true,
                selectedEventID: null
            };
        case actionTypes.GET_EVENTS_SUCCEEDED:
            if(action.events.length === 0) {
                return {...state, loading: false, noMoreEvents: true}
            } else {
                return {
                    ...state,
                    events: state.events && !action.refresh ? [
                        ...state.events,
                        ...action.events
                    ] : action.events,
                    loading: false,
                    first: action.first + 6
                };
            }
        case actionTypes.GET_EVENTS_FAIL:
            return {
                ...state,
                loading: false,
            };
        case actionTypes.GET_SHOP_SUCCEEDED:
            return {
                ...state,
                events: null,
                first: 0,
                selectedEventID: null
            };
        case actionTypes.RESET_EVENTS:
            return {
                ...state,
                first: 0,
                events: []
            };
        case actionTypes.SELECT_EVENT:
            const {eventID} = action;
            return {
                ...state,
                selectedEventID: eventID
            };
        default:
            return {
                ...state
            };
    }
};

export default reducer;
